module.exports = __webpack_public_path__ + "img/8c8b52de1bbedaa940a50f55fdbd9217.png";